<template>
  <img alt="Logo" v-if="src" class="h-10 w-auto" v-bind="$attrs" :src="src" />
  <svg
    v-else
    v-bind="$attrs"
    class="h-10 w-auto"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 139.21 31.88">
    <g data-name="Capa 2">
      <g data-name="Capa 1">
        <path
          d="M41.61 28.89a10.06 10.06 0 01-7.41 3 10.21 10.21 0 01-10.39-10.4 10.3 10.3 0 0110.39-10.4 10.36 10.36 0 0110.44 10.4 10.07 10.07 0 01-3.03 7.4zm-11.23-3.5a5.53 5.53 0 007.64 0 5.28 5.28 0 001.54-3.9 5.25 5.25 0 00-1.56-3.9 5.51 5.51 0 00-7.64 0 5.47 5.47 0 00-1.49 3.9 5.47 5.47 0 001.51 3.9zM61 22.28V11.64h5.08v19.69H61v-2.2c-1.24 1.87-3.2 2.75-5.9 2.75a7.22 7.22 0 01-5.36-2.16 8.37 8.37 0 01-2.08-6V11.64h5.08V23.1a4.09 4.09 0 001 3 3.86 3.86 0 002.85 1.06 4.11 4.11 0 003.17-1.24A5.12 5.12 0 0061 22.28zm20.19-11.19a7 7 0 015.32 2.17 8.28 8.28 0 012.12 6v12.07h-5.08V19.87a4.12 4.12 0 00-1-3 3.83 3.83 0 00-2.86-1.06 4.14 4.14 0 00-3.17 1.24 5.17 5.17 0 00-1.16 3.64v10.64h-5.12V11.64h5.08v2.21q1.82-2.76 5.87-2.76zm16.31 6.15c0 .84 1.19 1.56 3.58 2.16a19.13 19.13 0 012.29.65 10.69 10.69 0 012.07 1.06 4.76 4.76 0 011.63 1.89 5.69 5.69 0 01.59 2.63 5.44 5.44 0 01-2.28 4.69 9.5 9.5 0 01-5.63 1.61q-6.07 0-8.27-4.68l4.41-2.48a3.69 3.69 0 003.86 2.56c1.81 0 2.71-.57 2.71-1.7 0-.84-1.19-1.56-3.58-2.16-.89-.24-1.66-.47-2.29-.71a11.94 11.94 0 01-2-1 4.55 4.55 0 01-1.68-1.78 5.35 5.35 0 01-.57-2.54 5.45 5.45 0 012.13-4.56 8.42 8.42 0 015.35-1.7 8.87 8.87 0 014.38 1.09 8 8 0 013.11 3.09l-4.34 2.36a3.24 3.24 0 00-3.15-2 2.8 2.8 0 00-1.63.45 1.39 1.39 0 00-.69 1.07zm32.89 6.34h-14.85c.66 2.46 2.51 3.7 5.56 3.7a5.21 5.21 0 004.41-2l4.09 2.36a9.75 9.75 0 01-8.6 4.24 10.59 10.59 0 01-7.84-2.95 10.08 10.08 0 01-3-7.44 10.19 10.19 0 012.91-7.4 9.9 9.9 0 017.48-3 9.24 9.24 0 017.13 3 10.34 10.34 0 012.84 7.4 14.29 14.29 0 01-.13 2.09zm-14.92-3.94h10a4.77 4.77 0 00-4.89-4 5.36 5.36 0 00-3.38 1 4.94 4.94 0 00-1.73 3zm-97.38-5.51a10 10 0 00-7.4-3 10.16 10.16 0 00-5.61 1.59V0H0v31.33h5.08v-1a10.26 10.26 0 005.61 1.55 10.28 10.28 0 0010.43-10.39 10 10 0 00-3.03-7.36zm-3.58 11.26a5.21 5.21 0 01-3.82 1.53 5.18 5.18 0 01-3.82-1.53 5.44 5.44 0 01-1.5-3.9 5.44 5.44 0 011.5-3.9 5.19 5.19 0 013.82-1.54 5.22 5.22 0 013.82 1.54 5.28 5.28 0 011.49 3.9 5.31 5.31 0 01-1.49 3.9zM134.13 0v16.98l5.08-5.09V0h-5.08z"
          :fill="primaryColor" />
        <path :fill="accentColor" d="M134.13 19.83v11.49h5.08V16l-5.08 3.83z" />
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts">
import { defineComponent, computed } from 'vue';

defineComponent({
  name: 'Logo',
});

const props = defineProps<{
  type?: string | 'light' | 'dark' | 'white' | 'black';
  color?: string;
  src?: string;
  height?: string;
  width?: string;
}>();

const primary = '#4c20d0';
const accent = '#3ad8ce';
const black = '#00c0b5';
const white = '#FFFFFF';

const primaryColor = computed(() => {
  if (props.color) {
    return props.color;
  }

  if (props.type === 'light' || props.type === 'white') {
    return white;
  }

  if (props.type === 'dark' || props.type === 'black') {
    return black;
  }

  return primary;
});

const accentColor = computed(() => {
  if (props.color) {
    return props.color;
  }

  if (props.type === 'white') {
    return white;
  }

  if (props.type === 'black') {
    return black;
  }

  return accent;
});
</script>
